import React, {useEffect} from "react";
import Grid from "@mui/material/Grid";
import {Paper, Stack, styled, Typography} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {Icon} from "@iconify/react";
import {useSelector} from "react-redux";
import {RootState} from "../app/store";

interface StackRow{
    name : string,
    value : number
}
const StackRow = ({name,value} : StackRow) =>{
    return(
        <Stack alignItems="center">
            <Typography
            fontSize={18}
            color="#089BAB"
            fontWeight={400}
            letterSpacing={1}
            >
                {name}
            </Typography>
            <Typography
            fontSize={15}
            fontWeight={500}
            color="#121A2D"
            >
                {value.toString().length>0 ? value : "- -"}
            </Typography>
        </Stack>
    )
}

interface readings {
    "mm/Hg" ? : string,
    "mg/dL" ? : string,
    "bpm" ? :string,
    "SPO2" ? :string,
    "temp" ? :string
}

interface DashBoardCardinterface{
    id  : number,
    image : string,
    name  : string,
    readings : readings,
}

export const CategoryCard = ({ image , name , readings, id } : DashBoardCardinterface ) =>{

    const allDevices = useSelector(((state:RootState) => state.user.devices))
    const authUser = useSelector(((state:RootState) => state.auth.user))

    const navigate = useNavigate()
    const getCardData = () =>{

        let filteredDevices = allDevices.filter((d:any)=>d.category === name)

        navigate(
            `/Dashboard/${filteredDevices.length>0?filteredDevices[0].deviceId:"1"}/details/${name}/${authUser?authUser.userID:''}`
        )
    }



    return(
            <Grid item md={6} sm={10} xs={12} lg={4} xl={3}>
                <Stack spacing={2} alignItems="center" className="card-shadow" onClick={getCardData}>
                    <div className="dashboard--portrait">
                        <img src={image}/>
                    </div>
                    <Typography
                        fontSize={18}
                        fontWeight={500}
                        color="#121A2D"
                    >
                        {name.replaceAll('_',' ')}
                    </Typography>
                    <Typography
                        fontSize={14}
                        fontWeight={300}
                        color="#888C96"
                    >
                        {/*{measurements}*/}
                    </Typography>
                    <Stack direction="row" spacing={2}>
                        {
                            Object.entries(readings).map(e=>(
                                <StackRow name={e[0]} value={e[1]} key={e[0]} />
                            ))
                        }
                    </Stack>
                </Stack>
            </Grid>
    )
}